module.exports = __webpack_public_path__ + "static/media/plug.d8c74d11.svg";